import { createGlobalStyle } from "styled-components";
import { REGISTRATION_FOCUS_RING } from "./registrationTheme";

export const REGISTRATION_KEYBOARD_SCOPE_ATTR = {
  "data-registration-keyboard": "true",
};

export const RegistrationKeyboardFocusStyles = createGlobalStyle`
  [data-registration-keyboard="true"] button:focus-visible,
  [data-registration-keyboard="true"] a:focus-visible,
  [data-registration-keyboard="true"] input:focus-visible,
  [data-registration-keyboard="true"] select:focus-visible,
  [data-registration-keyboard="true"] [role="button"]:focus-visible,
  [data-registration-keyboard="true"] [role="option"]:focus-visible,
  [data-registration-keyboard="true"] [role="menuitem"]:focus-visible,
  [data-registration-keyboard="true"] [role="radio"]:focus-visible,
  [data-registration-keyboard="true"] [tabindex]:not([tabindex="-1"]):focus-visible,
  [data-registration-keyboard="true"] .registration-layout__navbar-back-btn:focus {
    outline: 3px solid ${REGISTRATION_FOCUS_RING};
    outline-offset: 2px;
  }

  [data-registration-keyboard="true"] .section-title:focus,
  [data-registration-keyboard="true"] .insurance-hero-title:focus,
  [data-registration-keyboard="true"] .coverage-found-title:focus,
  [data-registration-keyboard="true"] .discovery-checking-title:focus,
  [data-registration-keyboard="true"] .rd-profile-name:focus,
  [data-registration-keyboard="true"] .confirm-title:focus,
  [data-registration-keyboard="true"] .app-dl-title:focus,
  [data-registration-keyboard="true"] .all-set-title:focus,
  [data-registration-keyboard="true"] .no-rd-message:focus {
    outline: none;
  }
`;
